import { render, staticRenderFns } from "./Partie8.vue?vue&type=template&id=cf0bd0aa&"
import script from "./Partie8.vue?vue&type=script&lang=js&"
export * from "./Partie8.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports